import { SiteFooter } from '@/components/site-footer'
import { SiteHeader } from '@/components/site-header'
import { Download } from '@/components/download'

export default function DownloadsPage() {
  return (
    <div className="min-h-screen">
      <SiteHeader />
      <main>
        <section className="relative overflow-hidden py-14 text-center md:py-20">
          <div className="absolute inset-0 grid-bg opacity-60 [mask-image:linear-gradient(to_bottom,black,transparent)]" />
          <div className="relative mx-auto max-w-3xl px-4">
            <img
              src="/newemail-logo.svg"
              alt=""
              className="mx-auto h-16 w-16 rounded-2xl shadow-xl shadow-primary/20"
              width={64}
              height={64}
            />
            <h1 className="mt-6 text-balance text-4xl font-extrabold tracking-[-0.04em] sm:text-5xl">
              Download NewEmail
            </h1>
            <p className="mx-auto mt-4 max-w-xl text-pretty leading-relaxed text-muted-foreground">
              Your messages stay with your provider. NewEmail simply gives you a faster,
              more thoughtful place to read and write them.
            </p>
          </div>
        </section>
        <Download standalone />
        <section className="py-12">
          <div className="mx-auto grid max-w-5xl gap-4 px-4 sm:grid-cols-3">
            {[
              ['Standards first', 'Works with IMAP and SMTP providers you already trust.'],
              ['Local-first', 'Messages are cached for fast search and offline reading.'],
              ['Secure by default', 'Account passwords are stored in the system Keychain.'],
            ].map(([title, body]) => (
              <div key={title} className="rounded-xl border border-border bg-card p-5">
                <h2 className="font-bold">{title}</h2>
                <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{body}</p>
              </div>
            ))}
          </div>
        </section>
      </main>
      <SiteFooter />
    </div>
  )
}
